export default __webpack_public_path__ + "static/media/excel-detail.5468a22c.svg";